module.exports = {

    defaultLang: 'ru',

    data: {
        en: {
            секунда: 'second',
            секунды: 'seconds',
            секунд: 'seconds',
            минута: 'minute',
            минуты: 'minutes',
            минут: 'minutes',
            час: 'hour',
            часа: 'hours',
            часов: 'hours',
            день: 'day',
            дня: 'days',
            дней: 'days',
            неделя: 'week',
            недели: 'weeks',
            недель: 'weeks',
            месяц: 'month',
            месяца: 'months',
            месяцев: 'months',
            год: 'year',
            года: 'years',
            годов: 'years',
            и: 'and',
            или: 'or',
            Между: 'Between',
            'ничего нет': 'nothing yet'
        }
    },

    __: (key, lang) => {
        lang = lang || module.exports.defaultLang;
        return typeof module.exports.data[lang] !== 'undefined' && module.exports.data[lang][key] || key;
    },

    getPlural: (n, s1, s2, s3, lang = 'ru') => {
        return lang === module.exports.defaultLang
            ? app.string.getPlural(n, __(s1, lang), __(s2, lang), __(s3, lang))
            : app.string.getPluralEn(n, __(s1, lang), __(s2, lang));
    }

};

window.__ = module.exports.__;